import * as React from "react";
import { AlertActionType, useAlertContext } from "./AlertContext";
import { Alert, AlertGroup } from "@patternfly/react-core";
import "./AlertComponent.scss";
import { isEmpty } from 'lodash';

const AlertComponent: React.FC = () => {
  const {state, setAlertState} = useAlertContext();
  const [localState, setLocalState] = React.useState([]);
  const ALERT_TIMEOUT = (1000) * 5; // 5 seconds
  React.useEffect(()=>{
    if (state.alertState.length > localState.length) {
      setTimeout(()=> {
        setAlertState({
          type: AlertActionType.HIDE,
          payload: state.alertState[localState.length]
        });
      }, ALERT_TIMEOUT);
    }
    setLocalState(state.alertState);
    // eslint-disable-next-line
  }, [state.alertState]);
  return (
    <React.Fragment>
      <AlertGroup className="alert-group" isToast>
        {
          localState.map(({title, variant, description, id, actionLinks})=> (
            <Alert
              title={title}
              data-testid={title}
              variant={variant}
              {...(actionLinks.length > 0 &&
                {actionLinks: (<React.Fragment>
                    {actionLinks.map((actionLink)=> (actionLink))}
                </React.Fragment>)})}
              key={"alert-"+ id}>
            {!isEmpty(description) ? <p>{description}</p> : null}
            </Alert>
          ))
        }
      </AlertGroup>
    </React.Fragment>
  )
};

export default AlertComponent;
